<template>
	<div class="navbar">
		<!-- <svg-icon icon-class="loginbt" style="font-size:34px;margin-top:4px;position:absolute;right:0px;" @click="logout()"/> -->
		<!-- <search id="header-search" class="right-menu-item"/>
		<Screenfull id="screenfull" class="right-menu-item hover-effect" />
		<el-tooltip content="布局大小" effect="dark" placement="bottom">
			<size-select id="size-select" class="right-menu-item hover-effect" />
		</el-tooltip> -->
<!--
	 <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" style="position:relative;z-index:100000"/>
-->



    <div class="nav_message"   v-if="isProjectCommissioner">
      <el-badge :value="infoCount" :hidden="infoCount <= 0" class="item">
        <svg-icon icon-class="message" @click="drawer = true"/>
      </el-badge>
    </div>


    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      size="50%"  append-to-body >
      <el-form :model="queryParams" ref="queryForm" :inline="true" >
        <div class="el_top" >
          <el-form-item label="内容类型" prop="contentType" width="60">
            <el-select v-model="queryParams.contentType" placeholder="请选择" clearable size="small"  filterable @keyup.enter.native="handleQuery">
              <el-option v-for="dict in contentTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue" />
            </el-select>
          </el-form-item>

          <el-form-item label="内容" prop="content">
            <el-input v-model.trim="queryParams.content" placeholder="请输入" @keyup.enter.native="handleQuery" clearable />
          </el-form-item>
          <el-form-item class="btn_group">
            <el-button type="cyan" size="mini" @click="handleQuery" class="el_top_btn">搜索</el-button>
            <el-button size="mini" @click="resetQuery" class="el_top_btn btn_reset">重置</el-button>
          </el-form-item>
          </div>
        </el-form>
      <el-table :data="gridData" style ="margin-left:10px">
        <el-table-column property="createTime" label="日期" width="150" align="center"></el-table-column>
<!--        <el-table-column property="name" label="姓名" width="200"></el-table-column>-->
        <el-table-column label="内容类型" align="center" prop="contentType" :formatter="contentTypeFormat" width="100"/>
        <el-table-column property="content" label="内容" :show-overflow-tooltip="true" align="center"></el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" width="150"  >
          <template slot-scope="scope">
            <el-button  size="small" type="text" @click="handleReadFlag(scope.row)">标记已读</el-button>
<!--            <el-button  size="small" v-if="scope.row.contentType != 1 && scope.row.contentType != 7 && scope.row.contentType != 8" type="text" @click="handleJump(scope.row)">办理</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="infoCount>0" :total="infoCount" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                  @pagination="listTransfer" />
    </el-drawer>
		<div class="nav_user">
			<svg-icon icon-class="nav_user"/>
			<span>您好,{{ user.nickName }}</span>
			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<i class="el-icon-caret-bottom icon_click_menu" />
				<el-dropdown-menu slot="dropdown" class="nav_drop">
					<router-link to="/user/profile">
						<el-dropdown-item>个人中心</el-dropdown-item>
					</router-link>
					<el-dropdown-item @click.native="setting = true">
						<span>布局设置</span>
					</el-dropdown-item>
					<el-dropdown-item @click.native="logout()">
						<span>退出</span>
					</el-dropdown-item>
					<!-- <el-dropdown-item @click.native="bodylayout = true">
						<span>布局大小</span>
					</el-dropdown-item> -->
					<!-- <el-dropdown-item @click.native="drawer = true">
						<span>语言设置</span>
					</el-dropdown-item>

					<!-- <el-dropdown-item @click.native="logout">
						<span>修改密码</span>
					</el-dropdown-item> -->

				</el-dropdown-menu>
			</el-dropdown>
		</div>

		<!--语言设置-->
		<!-- <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false">
			<div>
				<language-select id="language-select" class="right-menu-item hover-effect" />
			</div>
		</el-drawer> -->

		<!-- append-to-body="true" 为必填项否则将不能置于body上层-->
<!--		<el-drawer title="我是标题" :visible.sync="bodylayout" :with-header="false" :append-to-body="true">-->
<!--			<div>-->
<!--				<size-select id="size-select" class="right-menu-item hover-effect" />-->
<!--			</div>-->
<!--		</el-drawer>-->
		<!-- <div class="right-menu">
			<template v-if="device!=='mobile'">
				<search id="header-search" class="right-menu-item" />
				<Screenfull id="screenfull" class="right-menu-item hover-effect" />
				<el-tooltip content="布局大小" effect="dark" placement="bottom">
					<size-select id="size-select" class="right-menu-item hover-effect" />
				</el-tooltip>
				<language-select id="language-select" class="right-menu-item hover-effect" />
			</template>

			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<div class="avatar-wrapper">
					<img :src="avatar" class="user-avatar">
					<i class="el-icon-caret-bottom" />
				</div>
				<el-dropdown-menu slot="dropdown">
					<router-link to="/user/profile">
						<el-dropdown-item>个人中心</el-dropdown-item>
					</router-link>
					<el-dropdown-item @click.native="setting = true">
						<span>布局设置</span>
					</el-dropdown-item>
					<el-dropdown-item divided @click.native="logout">
						<span>退出登录</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>


		</div> -->
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Breadcrumb from '@/components/Breadcrumb'
	import Hamburger from '@/components/Hamburger'
	import Screenfull from '@/components/Screenfull'
	import SizeSelect from '@/components/SizeSelect'
	import Search from '@/components/HeaderSearch'
	import {
		getUserProfile
	} from "@/api/system/user";
	import LanguageSelect from '@/components/LanguageSelect'
  import { listTransfer, getTransfer, delTransfer, addTransfer, updateTransfer } from "@/api/ywpx/project/transfer";
  import { checkPermi, checkRole } from "@/utils/permission"; // 权限判断函数
  import { getInfo } from "@/api/login"
  export default {
		components: {
			Breadcrumb,
			Hamburger,
			Screenfull,
			SizeSelect,
			Search,
			LanguageSelect,
		},
		data() {
			return {
				user: {},
				drawer: false,
				bodylayout:false,
        gridData: null,
        infoCount: 0,
        // 总条数
        total: 0,
        // 项目管理处长
        isProjectCommissioner:false,
        contentTypeOptions:[],
        roleTypesMapping:{
          // 项目管理经办
          isProjectCommissioner:["admin","infoAdmin","projectAdministrativeHandle","undertakeHandle","airlineSalesman","businessSecretary"
            ,"commercialCounsellor"],
        },
        queryParams: {
           pageNum: 1,
           pageSize: 10,
          contentType:"",
          readFlag:0,
        },
			};
		},
		computed: {
			...mapGetters([
				'sidebar',
				'avatar',
				'device'
			]),
			setting: {
				get() {
					return this.$store.state.settings.showSettings
				},
				set(val) {
					this.$store.dispatch('settings/changeSetting', {
						key: 'showSettings',
						value: val
					})
				}
			}
		},
		methods: {
			toggleSideBar() {
				this.$store.dispatch('app/toggleSideBar')
			},
			async logout() {
				this.$confirm('确定注销并退出系统吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$store.dispatch('LogOut').then(() => {
						location.href = '/index';
					})
				})
			},
			getUser() {
				getUserProfile().then(response => {
					this.user = response.data;
				});
			},
      /** 内容类型字典翻译*/
      contentTypeFormat(row, column) {
        return this.selectDictLabel(this.contentTypeOptions, row.contentType);
      },
      listTransfer(){
        getInfo().then(response => {
          this.currentUser = response.user;
          if (!response.user.admin){
            this.queryParams.receiverId = response.user.userId;
          }
          listTransfer(this.queryParams).then(response => {
            this.gridData = response.rows;
            this.infoCount = response.total;
          });

        });
      },
      // 标记已读
      handleReadFlag(row){
			  updateTransfer({"id":row.id,"readFlag":1}).then(response => {
            if(response.code == 200){
              this.msgSuccess("标记成功");
              this.listTransfer();
            }
        });
      },
      handleJump(row){
        this.drawer = false;
        // 实施方案
        if (row.contentType == 2){
          this.routerLink('/ywpx/project/intro', 'handle', row.pmProjectId,{"currentProcess":4})
        }else if (row.contentType == 4){// 项目简介
          if (row.project){
            if (row.project.projectType == 2 ){// 学历
              this.routerLink('/ywpx/project/educationIntro', 'handle', row.pmProjectId,{"currentProcess":2})
            }else{
              this.routerLink('/ywpx/project/intro', 'handle', row.pmProjectId,{"currentProcess":2})
            }
          }
        }else if (row.contentType == 3){//3未生成合同
          this.$router.push('/ywpx/officialDocument/contract/undertake/index/:source/:action/:projectId/:id/:projectType/:online/:projectCooperations')
        }else if (row.contentType == 5){// 5项目总结未上传
          if (row.project){
            if (row.project.projectType == 2 ){// 学历
              this.routerLink('/ywpx/project/educationIntro', 'handle', row.pmProjectId,{"currentProcess":6})
            }else{
              this.routerLink('/ywpx/project/intro', 'handle', row.pmProjectId,{"currentProcess":8})
            }
          }
        }else if (row.contentType == 6){// 6未结算
          this.$router.push('/ywpx/settlement/project/index');
        }
      },
      initRole(){
        // 项目管理处处长
        if (checkRole(this.roleTypesMapping.isProjectCommissioner)){
          this.isProjectCommissioner = true;
        }
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.listTransfer();
      },
      /** 重置按钮操作 */
      resetQuery() {
        this.resetForm("queryForm");
        this.handleQuery();
      },
      initDicts(){
        this.getDicts("transfer_type").then(response => {
          this.contentTypeOptions = response.data;
        });
      },
		},
		created() {
			this.getUser();
      let response = JSON.parse(localStorage.getItem("userInfo"));
      let roles = response.roles;
      // 如果不是评测才进行调用消息
      if (!roles.includes("pingce")){
        this.listTransfer();
      }
      this.initRole();
      this.initDicts();
		}
	}
</script>

<style lang="scss" scoped>
	.navbar {
		height: 50px;
		overflow: hidden;
		margin-right: 60px;
		position: relative;
		/* background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08); */

		.hamburger-container {
			line-height: 46px;
			height: 100%;
			float: left;
			cursor: pointer;
			transition: background .3s;
			-webkit-tap-highlight-color: transparent;

			&:hover {
				background: rgba(0, 0, 0, .025)
			}
		}

		.breadcrumb-container {
			float: left;
		}

		.errLog-container {
			display: inline-block;
			vertical-align: top;
		}

		.right-menu {
			float: right;
			height: 100%;
			line-height: 50px;

			&:focus {
				outline: none;
			}

			.right-menu-item {
				display: inline-block;
				padding: 0 8px;
				height: 100%;
				font-size: 18px;
				color: #5a5e66;
				vertical-align: text-bottom;

				&.hover-effect {
					cursor: pointer;
					transition: background .3s;

					&:hover {
						background: rgba(0, 0, 0, .025)
					}
				}
			}

			.avatar-container {
				margin-right: 30px;

				.avatar-wrapper {
					margin-top: 5px;
					position: relative;

					.user-avatar {
						cursor: pointer;
						width: 40px;
						height: 40px;
						border-radius: 10px;
					}

					.el-icon-caret-bottom {
						cursor: pointer;
						position: absolute;
						right: -20px;
						top: 25px;
						font-size: 12px;
					}
				}
			}
		}
	}
</style>

<style>
  .nav_message{
    position: absolute;
    top:10px;
    color: #f6f7ff;
  }
	.nav_user {
		max-width: 220px;
		height: 40px;
		/* border: 1px #797979 solid; */
		position: absolute;
		border-radius: 78px;
		background-color: #ffffff;
		-webkit-box-shadow: 5px 5px 11px rgba(67, 67, 67, 0.349019607843137);
		    box-shadow: 5px 5px 11px rgba(67, 67, 67, 0.349019607843137);
		text-align: center;
		line-height: 40px;
		right: 20px;
	}
	.nav_user .el-dropdown {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		cursor: pointer;
	}
	.nav_user .el-dropdown .icon_click_menu {
		width: 100%;
		height: 100%;
	}
	.nav_user .el-dropdown .icon_click_menu.el-icon-caret-bottom:before {
	    position: absolute;
	    top: 13px;
	    right: 7px;
	}

	.nav_user span {
		font-family: 'Microsoft YaHei UI';
		font-weight: 400;
		font-style: normal;
		font-size: 14px;
		display:block;
		color: #1C81D9;
		float:left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
		max-width: 138px;
		margin-right: 25px;
	}

	.nav_user svg {
		font-size: 24px;
		margin:7px 13px 0px 16px!important;
		display:block!important;
		float:left;
	}

	.nav_drop {
		right:100px;
		left:inherit!important;

	}

	.nav_drop .el-dropdown-menu__item {
		padding: 3px 52px !important;
		text-align: center;
	}

	.nav_drop .popper__arrow {
		left: 80px !important;

	}
	/* .v-modal{
		display:none!important;
	} */
	.el-icon-caret-bottom{
		color:#1C81D9;
		/* font-size:18px; */
	}
	.nav_user{
		color:#1C81D9;
	}

	/* 手机端（<992px）：用户胶囊收窄，避免挤压顶部菜单 */
	@media (max-width: 991px) {
		.nav_user {
			max-width: 140px;
			height: 34px;
			line-height: 34px;
			right: 10px;
		}

		.nav_user span {
			max-width: 72px;
			margin-right: 20px;
			font-size: 12px;
		}

		.nav_user svg {
			font-size: 20px;
			margin: 6px 8px 0 10px !important;
		}

		.nav_drop {
			right: 20px;
		}

		.nav_message {
			top: 8px;
		}
	}
</style>
